import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SEO } from "@/components/common/SEO";
import { Loader2, ArrowRight } from "lucide-react";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    api.get("/brands").then((r) => setBrands(r.data)).finally(() => setBusy(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14" data-testid="brands-page">
      <SEO title="All Car Brands in India"
        description="Explore every major car brand sold in India — Maruti Suzuki, Tata, Mahindra, Hyundai, Kia, Toyota and more. Compare models, prices and reviews."
      />
      <div className="mb-10">
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Brands</div>
        <h1 className="font-display text-4xl sm:text-5xl mt-2 tracking-tighter">All car brands in India</h1>
        <p className="mt-3 text-muted-foreground max-w-2xl">From value-focused Indian brands to European luxury marques — pick a brand to browse its full lineup, prices and specs.</p>
      </div>
      {busy ? (
        <div className="grid place-items-center py-20 text-muted-foreground"><Loader2 className="w-5 h-5 animate-spin"/></div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {brands.map((b) => (
            <Link key={b.slug} to={`/brands/${b.slug}`} data-testid={`brand-card-${b.slug}`}
              className="card-premium p-5 hover:border-blue-400 transition-all group">
              <div className="flex items-center gap-3">
                {b.logo_url ? (
                  <img src={b.logo_url} alt={b.name} loading="lazy" className="w-12 h-12 object-contain rounded-xl bg-[#F3F6FA] border border-[#E5E7EB]"/>
                ) : (
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-50 to-teal-50 border border-[#E5E7EB] grid place-items-center font-display text-xl text-blue-700">{b.name?.[0]}</div>
                )}
                <div>
                  <div className="font-display text-lg tracking-tight">{b.name}</div>
                  <div className="text-xs text-muted-foreground">{b.country}</div>
                </div>
              </div>
              {b.description && <p className="mt-3 text-sm text-muted-foreground line-clamp-2">{b.description}</p>}
              <div className="mt-3 text-xs text-blue-600 inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                Explore <ArrowRight className="w-3 h-3"/>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
